import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3525fc20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "error" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "ERROR", -1))

import { ref } from '@vue/reactivity';

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorView',
  setup(__props) {

var message = ref('잘못된 경로입니다.');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_unref(message)), 1)
  ]))
}
}

})